export const depoimentos = [
  {
    id: 1,
    cliente: 'Paulo',
    role: 'Pequeno produtor (MA)',
    texto: '"Top demais esse AgroVacina, nunca vi nada assim aqui no campo. Agora sei certinho o dia das vacinas, não vou mais perder bicho por esquecimento."',
    categoria: 'pequeno'
  },
  {
    id: 2,
    cliente: 'Sebastião',
    role: 'Médio produtor (PI)',
    texto: '"Gostei demais do aplicativo, fácil de mexer, nem precisei pedir ajuda. Já cadastrei minhas vacas e quero cadastrar os cavalos também."',
    categoria: 'medio'
  },
  {
    id: 3,
    cliente: 'Raimunda',
    role: 'Pequena criadora (MA)',
    texto: '"Antes eu anotava tudo em caderno que sempre molhava ou perdia. Agora fica tudo salvo no celular, muito mais seguro."',
    categoria: 'pequeno'
  },
  {
    id: 4,
    cliente: 'José',
    role: 'Grande produtor (GO)',
    texto: '"O que achei mais importante é que, com o chip e a carteira digital, eu vou poder comprovar as vacinas e vender meus animais com mais confiança."',
    categoria: 'grande'
  },
  {
    id: 5,
    cliente: 'Antônio',
    role: 'Médio produtor (MA)',
    texto: '"Fiz o teste do MVP e vi que ajuda bastante na organização. Se conseguir integrar com o frigorífico vai ser ótimo pra nós."',
    categoria: 'medio'
  },
  {
    id: 6,
    cliente: 'Maria',
    role: 'Pequena produtora (TO)',
    texto: '"Eu vou querer e indicar pros vizinhos. A gente precisa disso aqui no campo, porque ninguém lembra de cabeça todas as vacinas."',
    categoria: 'pequeno'
  },
  {
    id: 7,
    cliente: 'Carlos',
    role: 'Médio produtor (BA)',
    texto: '"Com o AgroVacina eu consigo mostrar para compradores de outros estados que meus animais estão em dia. Isso vai abrir novas oportunidades de venda."',
    categoria: 'medio'
  },
  {
    id: 8,
    cliente: 'Dona Francisca',
    role: 'Produtora familiar (MA)',
    texto: '"Achei muito prático. Até meus filhos mexeram no aplicativo e me ajudaram a cadastrar o gado."',
    categoria: 'pequeno'
  },
  {
    id: 9,
    cliente: 'João',
    role: 'Produtor de grande porte (SP)',
    texto: '"A rastreabilidade digital que vocês oferecem é essencial para quem quer exportar. O sistema está bem estruturado."',
    categoria: 'grande'
  },
  {
    id: 10,
    cliente: 'Rafael',
    role: 'Pequeno produtor (MA)',
    texto: '"Eu já cadastrei meu rebanho e vi as estatísticas da região. Isso dá até mais segurança na hora de conversar com o veterinário e planejar as próximas vacinas."',
    categoria: 'pequeno'
  }
];